import { RentingPeriod } from '@telialt/models/src/EshopModel';
import { useSegment } from '@telialt/utils/src/segment';

import { ESHOP_MUTATION_KEY } from '../../model';
import { apiUpdateRentingPlan } from '../../store/api';
import { useCartQuery } from '../queries/useCartQuery';
import { useMutationWithCartRefresh } from './useMutationWithCartRefresh';

export const useUpdateRentingPlanMutation = () => {
    const segment = useSegment();
    const { cartId } = useCartQuery();
    const { mutate, error, isPending } = useMutationWithCartRefresh(
        async (rentingPeriod: RentingPeriod) => {
            const { data } = await apiUpdateRentingPlan(segment, cartId, rentingPeriod);

            return data;
        },
        { mutationKey: [ESHOP_MUTATION_KEY.UPDATE_RENTING_PLAN] },
    );

    return {
        updateRentingPlan: mutate,
        updateRentingPlanIsLoading: isPending,
        updateRentingPlanError: error,
    };
};
